import Recommended from './RecommendedProducts';
export { SepararelyLoadedRecommendedProducts } from './SeparatelyLoadedRecommendedProducts';

export default Recommended;


// WEBPACK FOOTER //
// ./src/components/RecommendedProducts/index.tsx